const CUG_RATE_RULE_KEYWORDS = ['le_standard', 'le_mobile']

export function isEligibleMetasearchCugRateRule(ruleId: string | undefined): boolean {
  if (!ruleId) return false

  const normalizedRuleId = ruleId.toLowerCase()
  return CUG_RATE_RULE_KEYWORDS.some(keyword => normalizedRuleId.startsWith(keyword))
}
